import type { ThemeProps } from "models/styles/theme";
import styled from "styled-components/macro";
import { CssGrid, CssIcon } from "styles/helpers/layout";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledProductSelectorItem = styled(CssGrid)<ThemeProps>`
  font-weight: ${({ theme }) => theme.font.weight.normal};
  font-size: ${({ theme }) => theme.font.size._14};
  margin-bottom: 0.5rem;
  margin-left: 0rem;
  background-color: ${({ theme }) => theme.palette.secondary._700};
  padding: 0.8rem 1rem;
  border-radius: 0.7rem;
  
  grid-template-columns: ${calculateRem(23)} 1fr;
  column-gap: 1rem;
  align-items: center;
  justify-items: left;
  color: ${({ theme }) => theme.palette.neutral.white};
  > :first-child
  {
    align-self: center;
    justify-self: center;
  }
`;

export const StyledIcon = styled(CssIcon)`
  color: ${(props: ThemeProps) => props.theme.palette.neutral.white};
  font-size: ${(props: ThemeProps) => props.theme.font.size._16};
  font-weight: ${(props: ThemeProps) => props.theme.font.weight.normal};
  align-self: center;
  justify-self: center;
`;
